import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
// import Popup from 'reactjs-popup';
// import 'reactjs-popup/dist/index.css';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import EnquiryForm from '../components/EnquiryForm';
import Projects from '../components/projects';
import ClientTestimonial from '../components/ClientTestimonial';
import Counter from '../components/Counter';
import WhatLookingFor from '../components/WhatLookingFor';
import WhyChooseUs from '../components/WhyChooseUs';
import {BsPhone, BsTelephone, BsEnvelope,} from "react-icons/bs";
import ContactBg from '../assets/images/contact-bg.jpg';
import CommonHelmet from '../components/CommonHelmet';
import UnderBanner from '../components/UnderBanner';
import axiosInstance from '../axiosInstance';

const Home = () => {
    const title='Best Real Estate Company Lucknow | Urbanaidinfratech';
    const description='Urbanaidinfratech is one of the leading Real Estate company in Lucknow. Get luxurious homes in ready to move condition at most prime locations at lucrative prices.';
    const canonical='/home';
    // const childRef = useRef();
    // const clickShowPopup = () => childRef.current.showPopUp();
    const [contactData, setContactData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axiosInstance.get("/api/fetchcontactnew"); // Adjust port if needed
                const data = res.data[0] || {}; // Assuming data is an array
                
                          // Ensure mobile and email are arrays
                const mobile = Array.isArray(data.mobile)
                  ? data.mobile
                  : typeof data.mobile === 'string'
                    ? data.mobile.split(',').map(m => m.trim())
                    : [];

                const email = Array.isArray(data.email)
                  ? data.email
                  : typeof data.email === 'string'
                    ? data.email.split(',').map(e => e.trim())
                    : [];
                setContactData({ mobile, email });
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        };
        fetchData();
    }, []);
  
    return (
      <>        
        {/* <CommonPopup ref={childRef} />         */}
        <CommonHelmet title={title} canonical={canonical} description={description} />
        <Banner />
        <UnderBanner />
        <Projects />
        <section className="contact-information relative py-8">
        <div className='absolute right-0 bottom-0 h-full w-full -z-0 bg-no-repeat bg-cover bg-center bg-fixed bg-images1 opacity-5'></div>
          <div className='container mx-auto z-10 relative'>
              <div className='w-full md:px-7 px-0 py-4 flex flex-col justify-center items-center text-slate-950 gap-y-8'>
                <div className='w-full flex flex-col justify-center items-center'>
                  <div className='text-lg font-normal mb-1'>BOOK YOUR</div>
                  <div className='text-2xl text-center md:text-4xl font-bold leading-7 md:leading-[46px] text-orange-500'>Row House &<br></br>Commercial / Residential Plots</div>
                </div>
                <div className='w-full flex justify-center items-center'>
                  <div className='w-full flex flex-col items-center justify-center md:flex-row font-normal text-lg md:text-xl gap-2 md:gap-5 mt-3 md:mt-0'>
                    {contactData?.mobile?.map((mobile, idx) => (
                    <div key={idx} className='flex flex-row text-base md:text-xl items-center bg-white rounded-md overflow-hidden border border-solid border-gray-200'>
                      <span className='text-xl md:text-2xl px-3 py-2 bg-gray-600 text-white'><BsPhone /></span>
                      <span className='px-4'>+91-{mobile}</span>
                    </div>
                    ))}
                    
                    {contactData?.email?.[0] && (
                    <div className='flex flex-row text-base md:text-xl items-center bg-white rounded-md overflow-hidden border border-solid border-gray-200'>
                      <span className='text-xl md:text-2xl px-3 py-2 bg-gray-600 text-white'><BsEnvelope /></span>
                      <span className='px-4'><Link to={`mailto:${contactData.email[0]}`} className='hover:text-orange-500'>{contactData.email[0]}</Link></span>
                    </div>
                    )}
                  </div>
                </div>
              </div>
          </div>
        </section>
        <section className='contact-form relative py-12 before:absolute before:w-4/6 before:h-full before:left-0 before:top-0 before:bg-slate-600'>
          <div className='container mx-auto'>
            <div className='flex flex-col md:flex-row'>
              <div className='w-full md:w-1/2'></div>
              <div className='w-full md:w-1/2'>
                <EnquiryForm title={''} />
              </div>
            </div>
          </div>
        </section>
        <section className='counter flex py-4 bg-slate-950 bg-opacity-10'>
            <div className='container mx-auto'>
                <div className='w-full my-4 px-8 sm:px-0 py-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 grid-flow-row auto-rows-auto gap-10'>
                    <Counter />
                </div>
            </div>
        </section>
        
        <WhatLookingFor />
        <WhyChooseUs />
        <section className="contact-us relative bg-amber-300 py-16">
          <div className='absolute top-0 left-0 w-full h-full -z-0 bg-no-repeat bg-cover bg-center bg-fixed opacity-20' style={{backgroundImage:`url(${ContactBg})`}}></div>
          <div className='container mx-auto relative'>
            <div className='flex flex-col justify-center items-center text-slate-950'>
              <div className='flex uppercase text-2xl font-semibold text-center'>Are you looking for the best property in Lucknow?</div>
              <div className='flex text-base my-2'>We are ready to deliver your dream</div>
              <div className='flex mt-3'>
                <Link to='/contact-us' id='submit' className=' bg-orange-500 px-5 py-3 text-white hover:bg-sky-950'>Contact Us Now</Link>
              </div>
            </div>
          </div>
        </section>
        <ClientTestimonial />

      </>
    );
}

export default Home;